import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const CancelOrder = () => {
  const { orderId, productId } = useParams();
  const navigate = useNavigate();
  
  const [product, setProduct] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [refundMode, setRefundMode] = useState("");
  const [bankDetails, setBankDetails] = useState({
    accountNumber: "",
    ifscCode: "",
    accountHolder: "",
  });
  const [upiId, setUpiId] = useState("");
  // const [images, setImages] = useState([]);

  const paymentStatus = product?.payment_status;


  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    if (user_id && orderId && productId) {
      fetchOrderDetails();
    } else {
      setLoading(false);
    }
  }, [orderId, productId]);

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order",
        { user_id }
      );

      if (res.data.status === "true" || res.data.status === true) {
        const orders = res.data.data || [];
        const order = orders.find(o => o.order_id == orderId);
        
        if (order && order.items) {
          const productItem = order.items.find(item => item.product_id == productId);
          
          if (productItem) {
            setProduct(productItem);
            setOrderInfo(order);
          }
        }
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleImageUpload = (e) => {
  //   const files = Array.from(e.target.files);
  //   setImages(files);
  // };

  const updateOrderStatus = async () => {
  await axios.post(
    "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_new_order",
    {
      order_id: orderId,
      order_status: "Cancel",
      payment_status: paymentStatus === "Paid" ? "Paid" : "Pending",
    }
  );
};


  const handleSubmit = async () => {
  if (!reason || !comment) {
    alert("Please fill in all required fields");
    return;
  }

  // If payment is PAID, refund mode is mandatory
  if (paymentStatus === "Paid" && !refundMode) {
    alert("Please select refund mode");
    return;
  }

  // Bank validation
  if (
    paymentStatus === "Paid" &&
    refundMode === "bank" &&
    (!bankDetails.accountHolder ||
      !bankDetails.accountNumber ||
      !bankDetails.ifscCode)
  ) {
    alert("Please fill all bank details");
    return;
  }

  setSubmitting(true);

  try {
    /* ===============================
       1️⃣ UPDATE ORDER STATUS → Cancel
       =============================== */
    await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_new_order",
      {
        order_id: orderId,
        order_status: "Cancel",
        payment_status: paymentStatus, // Paid / Pending
      }
    );

    /* ======================================
       2️⃣ IF PAID → ADD CANCELLATION + REFUND
       ====================================== */
    if (paymentStatus === "Paid") {
      const formData = new FormData();
      formData.append("order_id", orderId);
      formData.append("user_id", user_id);
      formData.append("seller_id", product.seller_id);
      formData.append("reason_for_cancellation", reason);
      formData.append("comments", comment);

      if (refundMode === "wallet") {
        formData.append("upi_id", upiId);
      } else if (refundMode === "bank") {
        formData.append("account_holder_name", bankDetails.accountHolder);
        formData.append("account_number", bankDetails.accountNumber);
        formData.append("ifsc_code", bankDetails.ifscCode);
      }

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_cancellation",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!(res.data.status === true || res.data.status === "true")) {
        throw new Error("Cancellation request failed");
      }
    }

    /* ===============================
       3️⃣ SUCCESS
       =============================== */
    alert(
      paymentStatus === "Paid"
        ? "Order cancelled. Refund will be processed soon."
        : "Order cancelled successfully."
    );

    navigate(`/order-cancelled/${orderId}/${productId}`);

  } catch (error) {
    console.error("Cancel Order Error:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setSubmitting(false);
  }
};


  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to cancel order</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading order details...</h5>
      </div>
    );
  }

  if (!product || !orderInfo) {
    return (
      <div className="container py-5 text-center">
        <h5>Order not found</h5>
      </div>
    );
  }

  return (
    <div className="cancel-page" style={{ marginTop: "115px" }}>
      <div className="cancel-wrapper">
        {/* LEFT SECTION */}
        <div className="cancel-left">
          {/* STEP 1 */}
          <div className="cancel-card">
            <div className="step-header active">
              <span className="step-number">1</span>
              <h4>EASY CANCELLATION</h4>
            </div>

            <div className="form-body">
              <div className="form-row">
                <label>
                  Reason for Cancellation <span>*</span>
                </label>

                <div className="select-box">
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  >
                    <option value="">Select Reason</option>
                    <option>Item not required anymore</option>
                    <option>Found cheaper elsewhere</option>
                    <option>Ordered by mistake</option>
                    <option>Delivery taking too long</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <label>
                  Comments <span>*</span>
                </label>
                <textarea
                  placeholder="eg: Item not required anymore."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              {/* <div className="form-row">
                <label>Upload Images (Optional)</label>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {images.length > 0 && (
                  <small className="text-muted">{images.length} file(s) selected</small>
                )}
              </div> */}

              <div className="form-actions">
                <button
  className="submit-btn"
  disabled={submitting || (paymentStatus === "Paid" && !refundMode)}
  onClick={handleSubmit}
>
  {submitting
    ? "PROCESSING..."
    : paymentStatus === "Paid"
    ? "SUBMIT CANCELLATION REQUEST"
    : "CANCEL ORDER"}
</button>

              </div>
            </div>
          </div>

          {/* STEP 2 - REFUND MODES */}
          {paymentStatus === "Paid" && (
  <div className="cancel-card">

            <div className="step-header active">
              <span className="step-number">2</span>
              <h4>REFUND MODES</h4>
            </div>

            <div className="form-body">
              <p className="refund-info">
                Choose how you'd like to receive your refund
              </p>

              <div className="refund-options-horizontal">
                <label className="refund-option-card">
                  <input
                    type="radio"
                    name="refundMode"
                    value="wallet"
                    checked={refundMode === "wallet"}
                    onChange={(e) => setRefundMode(e.target.value)}
                  />
                  <div className="refund-content">
                    <strong>Refund to UPI</strong>
                    <small>Instant refund to your UPI ID</small>
                  </div>
                </label>

                <label className="refund-option-card">
                  <input
                    type="radio"
                    name="refundMode"
                    value="bank"
                    checked={refundMode === "bank"}
                    onChange={(e) => setRefundMode(e.target.value)}
                  />
                  <div className="refund-content">
                    <strong>Bank Transfer</strong>
                    <small>Direct transfer to your bank account (3-5 days)</small>
                  </div>
                </label>
              </div>

              {/* Conditional Bank Details Form */}
              {refundMode === "bank" && (
                <div className="bank-details-form">
                  <h5>Enter Bank Details</h5>
                  
                  <div className="form-row">
                    <label>
                      Account Holder Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter account holder name"
                      value={bankDetails.accountHolder}
                      onChange={(e) =>
                        setBankDetails({
                          ...bankDetails,
                          accountHolder: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="form-row">
                    <label>
                      Account Number <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter account number"
                      value={bankDetails.accountNumber}
                      onChange={(e) =>
                        setBankDetails({
                          ...bankDetails,
                          accountNumber: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="form-row">
                    <label>
                      IFSC Code <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter IFSC code"
                      value={bankDetails.ifscCode}
                      onChange={(e) =>
                        setBankDetails({
                          ...bankDetails,
                          ifscCode: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              )}

              {/* Conditional UPI Form */}
              {refundMode === "wallet" && (
                <div className="bank-details-form">
                  <div className="form-row">
                    <label>UPI ID (Optional)</label>
                    <input
                      type="text"
                      placeholder="Enter UPI ID (e.g., name@upi)"
                      value={upiId}
                      onChange={(e) => setUpiId(e.target.value)}
                    />
                  </div>
                  <p className="wallet-note">
                    Refund will be instantly credited to your Garshya wallet balance.
                  </p>
                </div>
              )}

              <div className="form-actions">
                <button
                  className="submit-btn"
                  disabled={!refundMode || submitting}
                  onClick={handleSubmit}
                  style={{
                    backgroundColor: "#ff6634",
                    color: "white",
                    padding: "12px 30px",
                    border: "none",
                    cursor: refundMode && !submitting ? "pointer" : "not-allowed",
                    opacity: refundMode && !submitting ? 1 : 0.6,
                  }}
                >
                  {submitting ? "SUBMITTING..." : "SUBMIT CANCELLATION REQUEST"}
                </button>
              </div>
            </div>
          </div>
          )}
        </div>

        {/* RIGHT SECTION */}
        <div className="cancel-right">
          <div className="item-card">
            <h5>ITEM DETAILS</h5>

            <div className="item-info">
              <div>
                <p className="item-title">
                  {product.product_name}
                </p>
                <p className="qty">Qty: {product.qty}</p>
                <h4>₹{product.subtotal || (product.price * product.qty)}</h4>
              </div>
               
              <div className="Product-image"> 
              <img
                src={
                  product.multi_image
                    ? `https://cyberathon.com/multivendor/${product.multi_image}`
                    : "https://via.placeholder.com/150"
                }
                alt={product.product_name}
              />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelOrder;